import { render, staticRenderFns } from "./page-monitor.vue?vue&type=template&id=3c77763f&scoped=true&"
import script from "./page-monitor.vue?vue&type=script&lang=js&"
export * from "./page-monitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c77763f",
  null
  
)

export default component.exports